<div class="detail-page toimittaja-katsele">
  <app-asiakas-otsikko otsikko="Toimittaja" [asiakas]="asiakas()"></app-asiakas-otsikko>

  <div class="toiminnot-yla">
    <app-secondary-button (click)="takaisin()" actionId="Palaa toimittajaselauslistaan">Takaisin listaan</app-secondary-button>
  </div>

  @if (toimittajaObservable | async; as t) {
    <div class="tiedot-grid">
      <div class="kentta">
        <div class="otsikko">Numero</div>
        <div class="arvo mono">{{ t.numero ?? '–' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Avain</div>
        <div class="arvo mono">{{ t.avain }}</div>
      </div>

      <div class="kentta laaja">
        <div class="otsikko">Nimi</div>
        <div class="arvo">{{ t.nimi || '–' }}</div>
      </div>
      <div class="kentta laaja">
        <div class="otsikko">Maksunsaaja</div>
        <div class="arvo">{{ t.maksunSaaja || '–' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Y-tunnus</div>
        <div class="arvo mono">{{ t.ytunnus || '–' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Tunnisteet</div>
        @if (t.tunnisteetData?.length) {
          <div class="arvo">
            @for (tunniste of t.tunnisteetData; track tunniste.arvo) {
              <div class="mono">{{ tunniste.arvo }} ({{ tunniste.tyyppi }})</div>
            }
          </div>
        }
      </div>
      <div class="kentta">
        <div class="otsikko">Tila</div>
        <div class="arvo" [class.poistettu]="t.poistettu">{{ t.poistettu ? 'Poistettu' : 'Aktiivinen' }}</div>
      </div>

      <div class="kentta laaja">
        <div class="otsikko">Pankkitilit</div>
        @if ((ibanitObservable | async)?.length) {
          <table class="iban-taulukko">
            <thead>
              <tr>
                <th>IBAN</th>
                <th>BIC</th>
                <th>Tyyppi</th>
              </tr>
            </thead>
            <tbody>
              @for (i of ibanitObservable | async; track i.iban) {
                <tr>
                  <td class="mono">{{ i.iban }}</td>
                  <td class="mono">{{ i.bic || '–' }}</td>
                  <td>{{ i.tyyppi === 'oletus' ? 'Oletus' : 'Tavallinen' }}</td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <div class="arvo">–</div>
        }
      </div>

      <div class="kentta">
        <div class="otsikko">Luotu</div>
        <div class="arvo">{{ t.luotu?.toDate() | date: 'dd.MM.yyyy HH:mm' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Luoja</div>
        <div class="arvo">{{ annaKayttajanNimi(t.luoja, kayttajienNimetMapObservable | async) }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Päivitetty</div>
        <div class="arvo">{{ t.paivitetty?.toDate() | date: 'dd.MM.yyyy HH:mm' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Päivittäjä</div>
        <div class="arvo">{{ annaKayttajanNimi(t.paivittaja, kayttajienNimetMapObservable | async) }}</div>
      </div>
    </div>
  } @else {
    <div class="tyhja-tila">Toimittajaa ei löytynyt.</div>
  }
</div>
